import {Paths} from '../../../types/Paths';

/**
 * Gets name of the field from provided object type
 * In case of form array, it provides tuple for providing index and the field name
 */
export type FieldName<T, K = undefined> = K extends undefined
  ? T extends undefined
    ? string | string[]
    : keyof T | Paths<T>
  : T extends undefined
    ? string | string[]
    : [string, keyof T | Paths<T>];
